import styled from 'styled-components';
import { AIcon as AIconComponent } from '../../atoms/AIcon';
import { baseVariables } from '../../utils/TempMiUiLibraryUtils';

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  block-size: 2rem;
`;

export const AIcon = styled(AIconComponent)`
  .icon {
    color: var(--t-color-control-foreground-reverse, ${baseVariables.color.base10});
  }
`;
